import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useUserData } from "store/user-data";
import { getBusinessDetailsAction } from "action/misc-action";
import { useNavigate } from "react-router-dom";
import { routes } from "router";

const AccountCheckToast = () => {
  const { userData } = useUserData();
  const navigate = useNavigate();
  const hasChecked = useRef(false);

  useEffect(() => {
    // Only run this if the user is a manager (or business owner)
    // and we haven't already performed the check for this session/load
    if (
      userData &&
      (userData.is_manager || userData.is_business_owner) &&
      !hasChecked.current
    ) {
      getBusinessDetailsAction().then((response) => {
        if (response.status === 200) {
          const business = response.body;
          if (!business.bank_account?.account_number) {
            toast.error(
              "Please fill in your bank account details to complete your profile.",
              {
                duration: Infinity,
                id: "missing-bank-account-toast",
                action: {
                  label: "Go to Profile",
                  onClick: () => {
                    navigate(routes.ProfilePage.path);
                  },
                },
              },
            );
          }
        }
      });
      hasChecked.current = true;
    }
  }, [userData, navigate]);

  return null; // This component doesn't render anything visually
};

export default AccountCheckToast;
